export const NODE_NAME = 'bullet_list';

export const BULLET_LIST_REGEX = /^\s*([-+*])\s$/;
